import type { IconButtonProps } from '@mui/material';
import { styled, IconButton } from '@mui/material';
import React from 'react';

const Host = styled(IconButton)`
  padding: 0;
  background: transparent !important;
  &:hover {
    .MuiSvgIcon-root {
      color: ${(props) => props.theme.palette.monochrome.contrastText};
    }
  }
`;

export const SimpleIconButton = ({
  icon,
  onClick,
  ariaLabel,
  ...rest
}: {
  icon: React.ReactNode;
  onClick: () => void;
  ariaLabel: string;
} & IconButtonProps) => {
  return (
    <Host aria-label={ariaLabel} onClick={onClick} {...rest}>
      {icon}
    </Host>
  );
};
